module.exports = __webpack_public_path__ + "img/gb9115_20_a.prt.1c57dca9.jpg";